export default __webpack_public_path__ + "static/media/appleJuice.3b8938e6.jpg";